import React, { useState } from 'react';
import UploadBox from './UploadBox';

const UploadBoxDemo = () => {
  const [file, setFile] = useState(null);

  return (
    <div style={{
      minHeight: '100vh',
      background: `
        linear-gradient(135deg, #667eea 0%, #764ba2 100%),
        radial-gradient(circle at 20% 80%, #f093fb 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, #f5576c 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, #4facfe 0%, transparent 50%)
      `,
      backgroundBlendMode: 'overlay, screen, screen, screen',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '32px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <h2 style={{ color: 'white', fontSize: '2rem', margin: 0 }}>UploadBox Demo</h2>
      <UploadBox
        label="Upload your image"
        value={file}
        onChange={setFile}
        style={{ maxWidth: 400, width: '100%' }}
      />
      {file && (
        <div style={{ color: 'white', marginTop: 16 }}>
          <b>File:</b> {file.name}
        </div>
      )}
    </div>
  );
};

export default UploadBoxDemo; 